import React, { useState } from "react";

const Game = ({ handleClick, teams, round, game }) => {
  const [picked1, setPicked1] = useState(false);
  const [picked2, setPicked2] = useState(false);
  const t1 = "t1";
  const t2 = "t2";
  const setPicked = (t) => {
    if (t === "t1") {
      setPicked2(false);
      setPicked1(true);
    } else {
      setPicked1(false);
      setPicked2(true);
    }
  };

  return (
    <div className="game">
      <div
        onClick={() => handleClick(teams[0], round, game, setPicked, t1)}
        className="team"
        style={{
          backgroundImage: teams[0] ? `url(${teams[0]["logo"]})` : null,
          backgroundSize: "contain",
          boxShadow: picked1 ? "3px 2px 2px blue" : "none",
          border: picked1 ? "2px solid blue" : 0
        }}
      ></div>
      <div
        onClick={() => handleClick(teams[1], round, game, setPicked, t2)}
        className="team"
        style={{
          backgroundImage: teams[1] ? `url(${teams[1].logo})` : null,
          backgroundSize: "contain",
          boxShadow: picked2 ? "3px 2px 2px blue" : "none",
          border: picked2 ? "2px solid blue" : 0
        }}
      ></div>
    </div>
  );
};

export default Game;
